// Class: starling.filters.FilterChain

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $bind = require("./../../bind_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_filters_FragmentFilter() {return require("./../../starling/filters/FragmentFilter");}
function openfl__$Vector_Vector_$Impl_$() {return require("./../../openfl/_Vector/Vector_Impl_");}
function starling_utils_Padding() {return require("./../../starling/utils/Padding");}
function js__$Boot_HaxeError() {return require("./../../js/_Boot/HaxeError");}
function openfl_errors_ArgumentError() {return $import(require("openfl/errors/ArgumentError"));}

// Constructor

var FilterChain = function(args) {
	(starling_filters_FragmentFilter().default).call(this);
	this._filters = (openfl__$Vector_Vector_$Impl_$().default)._new();
	var len = args.length;
	var _g1 = 0;
	var _g = len;
	while(_g1 < _g) {
		var i = _g1++;
		var filter = args[i];
		if(filter != null) {
			this.addFilterAt(filter,i);
		} else {
			throw new (js__$Boot_HaxeError().default)(new (openfl_errors_ArgumentError().default)("pass only fragment filters to the constructor"));
		}
	}
	this.updatePadding();
	this.addEventListener("enterFrame",$bind(this,this.__onEnterFrame));
}

// Meta

FilterChain.__name__ = ["starling","filters","FilterChain"];
FilterChain.__super__ = (starling_filters_FragmentFilter().default);
FilterChain.prototype = $extend((starling_filters_FragmentFilter().default).prototype, {
	dispose: function() {
		var _g = 0;
		var _g1 = this._filters;
		while(_g < _g1.length) {
			var filter = _g1[_g];
			++_g;
			filter.dispose();
		}
		this._filters.length = 0;
		(starling_filters_FragmentFilter().default).prototype.dispose.call(this);
	},
	setRequiresRedraw: function() {
		this.updatePadding();
		(starling_filters_FragmentFilter().default).prototype.setRequiresRedraw.call(this);
	},
	process: function(painter,helper,input0,input1,input2,input3) {
		var numFilters = this._filters.length;
		var outTexture = input0;
		var inTexture;
		var _g1 = 0;
		var _g = numFilters;
		while(_g1 < _g) {
			var i = _g1++;
			inTexture = outTexture;
			outTexture = this._filters[i].process(painter,helper,inTexture);
			if(i != 0) {
				helper.putTexture(inTexture);
			}
		}
		return outTexture;
	},
	get_numPasses: function() {
		var numPasses = 0;
		var numFilters = this._filters.length;
		var _g1 = 0;
		var _g = numFilters;
		while(_g1 < _g) {
			var i = _g1++;
			numPasses += this._filters[i].get_numPasses();
		}
		return numPasses;
	},
	getFilterAt: function(index) {
		if(index < 0) {
			index += this.get_numFilters();
		}
		return this._filters[index];
	},
	addFilter: function(filter) {
		this.addFilterAt(filter,this._filters.length);
	},
	addFilterAt: function(filter,index) {
		(openfl__$Vector_Vector_$Impl_$().default).insertAt(this._filters,index,filter);
		filter.addEventListener("change",$bind(this,this.setRequiresRedraw));
		this.setRequiresRedraw();
	},
	removeFilter: function(filter,dispose) {
		if(dispose == null) {
			dispose = false;
		}
		var filterIndex = this.getFilterIndex(filter);
		if(filterIndex != -1) {
			this.removeFilterAt(filterIndex,dispose);
		}
		return filter;
	},
	removeFilterAt: function(index,dispose) {
		if(dispose == null) {
			dispose = false;
		}
		var filter = (openfl__$Vector_Vector_$Impl_$().default).removeAt(this._filters,index);
		filter.removeEventListener("change",$bind(this,this.setRequiresRedraw));
		if(dispose) {
			filter.dispose();
		}
		this.setRequiresRedraw();
		return filter;
	},
	getFilterIndex: function(filter) {
		var this1 = this._filters;
		return Array.prototype.indexOf.call(this1,filter,0);
	},
	updatePadding: function() {
		FilterChain.sPadding.setTo();
		var _g = 0;
		var _g1 = this._filters;
		while(_g < _g1.length) {
			var filter = _g1[_g];
			++_g;
			var padding = filter.get_padding();
			if(padding.get_left() > FilterChain.sPadding.get_left()) {
				FilterChain.sPadding.set_left(padding.get_left());
			}
			if(padding.get_right() > FilterChain.sPadding.get_right()) {
				FilterChain.sPadding.set_right(padding.get_right());
			}
			if(padding.get_top() > FilterChain.sPadding.get_top()) {
				FilterChain.sPadding.set_top(padding.get_top());
			}
			if(padding.get_bottom() > FilterChain.sPadding.get_bottom()) {
				FilterChain.sPadding.set_bottom(padding.get_bottom());
			}
		}
		this.get_padding().copyFrom(FilterChain.sPadding);
	},
	__onEnterFrame: function(event) {
		var numFilters = this._filters.length;
		var _g1 = 0;
		var _g = numFilters;
		while(_g1 < _g) {
			var i = _g1++;
			this._filters[i].dispatchEvent(event);
		}
	},
	get_numFilters: function() {
		return this._filters.length;
	}
});
FilterChain.prototype.__class__ = FilterChain.prototype.constructor = $hxClasses["starling.filters.FilterChain"] = FilterChain;

// Init

Object.defineProperties(FilterChain.prototype,{ "numFilters" : { get : function () { return this.get_numFilters (); }}});

// Statics


FilterChain.sPadding = new (starling_utils_Padding().default)()

// Export

exports.default = FilterChain;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/filters/FilterChain.js
// module id = 325
// module chunks = 0